import Vue from "vue";
import VueRouter from "vue-router";
import VictimasHome from "./pages/victimas/list.vue";
import VictimasDetail from "./pages/victimas/detail.vue";
import CondenadosHome from "./pages/condenados/index.vue";
import CondenadosDetail from "./pages/condenados/detail.vue";
import About from "./views/About.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: VictimasHome,
  },
  {
    path: "/victimas/",
    name: "Victimas",
    component: VictimasHome,
  },
  {
    path: "/detalle/:id",
    name: "VictimaDetail",
    component: VictimasDetail,
  },
  {
    path: "/condenados",
    name: "Condenados",
    component: CondenadosHome,
  },
  {
    path: "/condenados/:id",
    name: "CondenadoDetail",
    component: CondenadosDetail,
  },
  {
    path: "/acerca-de",
    name: "About",
    component: About,
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/presentes/",
  routes,
});

export default router;
